import environment from './src/constants/environment';

export const onInitialClientRender = () => {
  if (typeof window !== 'undefined' && window.mixpanel) {
    window.mixpanel.init(environment.mixpanelKey, {
      track_page_view: false,
    });
  }
};
